import React from 'react'
import { motion } from 'framer-motion'

const Om = () => {
  return (
    <div 
        name="Om" 
        className='w-full min-h-screen bg-gradient-to-b from-white to-white text-black pt-32 pb-32 sm:pt-20'
    >
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <motion.div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-black'>About</p>
            </motion.div>

            <div className='flex flex-col gap-6 sm:gap-4 text-lg sm:text-base'>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 2.4 }}
                    className='font-bold text-xl sm:text-lg'
                >
                    Experience
                </motion.p>
                
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 2.8 }}
                    className='max-w-prose'
                >
                    I currently work as a Business Controller at DHL, the world’s largest logistics company, where I co-control a business generating billions (DKK) in revenue. From the 1st of July 2025 I will be working as a business controller at DB Cargo.
                </motion.p>

                <div className='h-4 sm:h-2'></div>

                {/* Add Education Section */}
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 3.2 }}
                    className='font-bold text-xl sm:text-lg'
                >
                    Education
                </motion.p>

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 3.6 }}
                    className='max-w-prose'
                >
                    I hold a MSc in economics with a specialization in finance (Cand.polit) from University of Copenhagen with a grade point average of 10 (A). 
                </motion.p>

                <div className='h-4 sm:h-2'></div>

                <motion.p 
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 4 }}
                    className='font-bold text-xl sm:text-lg'
                >
                    How I Help Businesses
                </motion.p>

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 4.4 }}
                    className='max-w-prose'
                >
                    Financial success hinges on a clear understanding of the business' current operations. In the role of business controlling, I analyze and set up control frameworks that ensure that each action turns to the right amount of gross profit in-line with the vision of management.
                </motion.p>

                <div className='h-4 sm:h-2'></div>

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 4.8 }}
                    className='max-w-prose'
                >
                    In the role of business partner, we might evaluate the ROI of the enterprises projects to prioritize those with the greatest potential, or streamline operations to reduce costs without compromising quality. Once we identify high-impact opportunities, I work with the team to implement best practices across the organization, boosting profitability.
                </motion.p>

                <div className='h-4 sm:h-2'></div>

                

                <div className='h-4 sm:h-2'></div>

            
            
                
            </div>
        </div>
    </div>
  )
}

export default Om